import React from "react";

// Header sticky de una pantalla del drill-down de torneos.
// - onBack presente => muestra la flecha "Volver" a la izquierda.
// - variant "home" => usa el look del header violeta (.tournament-header).
// - right => slot para una acción a la derecha (ej. botón Guardar).
export default function NavHeader({ title, subtitle, onBack, right, variant }) {
  const isHome = variant === "home";
  return (
    <div className={"drill-header" + (isHome ? " drill-header--home" : "")}>
      <div className="d-flex align-items-center" style={{ gap: "0.5rem", minWidth: 0 }}>
        {onBack && (
          <button type="button" className="drill-back" onClick={onBack} aria-label="Volver">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
              <polyline points="15 18 9 12 15 6" />
            </svg>
          </button>
        )}
        <div style={{ minWidth: 0 }}>
          <div className="drill-title">{title}</div>
          {subtitle && <div className="drill-subtitle">{subtitle}</div>}
        </div>
      </div>
      {right && <div className="d-flex align-items-center">{right}</div>}
    </div>
  );
}
